"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Static = void 0;
var getProto_1 = __importDefault(require("licia/getProto"));
var isNum_1 = __importDefault(require("licia/isNum"));
var isBool_1 = __importDefault(require("licia/isBool"));
var lowerCase_1 = __importDefault(require("licia/lowerCase"));
var isObj_1 = __importDefault(require("licia/isObj"));
var isArr_1 = __importDefault(require("licia/isArr"));
var upperFirst_1 = __importDefault(require("licia/upperFirst"));
var keys_1 = __importDefault(require("licia/keys"));
var each_1 = __importDefault(require("licia/each"));
var toSrc_1 = __importDefault(require("licia/toSrc"));
var isPromise_1 = __importDefault(require("licia/isPromise"));
var type_1 = __importDefault(require("licia/type"));
var _1 = __importDefault(require("licia/$"));
var difference_1 = __importDefault(require("licia/difference"));
var allKeys_1 = __importDefault(require("licia/allKeys"));
var filter_1 = __importDefault(require("licia/filter"));
var chunk_1 = __importDefault(require("licia/chunk"));
var toStr_1 = __importDefault(require("licia/toStr"));
var noop_1 = __importDefault(require("licia/noop"));
var extend_1 = __importDefault(require("licia/extend"));
var naturalSort_1 = __importDefault(require("licia/naturalSort"));
var Visitor_1 = __importDefault(require("./Visitor"));
var util_1 = require("./util");
var Static_1 = __importDefault(require("./Static"));
exports.Static = Static_1.default;
var Component_1 = __importDefault(require("../share/Component"));
var ObjectViewer = (function (_super) {
    __extends(ObjectViewer, _super);
    function ObjectViewer(container, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, container, { compName: 'object-viewer' }) || this;
        _this.onItemClick = function (e) {
            var _a = _this, map = _a.map, c = _a.c;
            var $this = (0, _1.default)(e.curTarget);
            var circularId = $this.data('object-id');
            var $firstSpan = $this.find('span').eq(0);
            if ($this.data('first-level'))
                return;
            if (circularId) {
                $this.find('ul').html(_this.objToHtml(map[circularId], false));
                $this.rmAttr('data-object-id');
            }
            e.stopImmediatePropagation();
            if (!$firstSpan.hasClass(c('expanded')))
                return;
            var $ul = $this.find('ul').eq(0);
            if ($firstSpan.hasClass(c('collapsed'))) {
                $firstSpan.rmClass(c('collapsed'));
                $ul.show();
            }
            else {
                $firstSpan.addClass(c('collapsed'));
                $ul.hide();
            }
            _this.emit('change');
        };
        _this.initOptions(options, {
            unenumerable: false,
            accessGetter: false,
        });
        _this.bindEvent();
        return _this;
    }
    ObjectViewer.prototype.set = function (data) {
        this.data = [data];
        this.visitor = new Visitor_1.default();
        this.map = {};
        this.render();
    };
    ObjectViewer.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.$container.off('click', 'li', this.onItemClick);
    };
    ObjectViewer.prototype.objToHtml = function (data, firstLevel) {
        var _this = this;
        var visitor = this.visitor;
        var self = data;
        var isBigArr = false;
        var visitedObj = visitor.get(data);
        if (visitedObj && visitedObj.self) {
            self = visitedObj.self;
        }
        var ret = '';
        var types = ['enumerable'];
        var enumerableKeys = (0, keys_1.default)(data);
        var unenumerableKeys = [];
        var symbolKeys = [];
        var virtualKeys = [];
        var virtualData = {};
        if (this.options.unenumerable && !firstLevel) {
            types.push('unenumerable');
            types.push('symbol');
            unenumerableKeys = (0, difference_1.default)((0, allKeys_1.default)(data, {
                prototype: false,
                unenumerable: true,
            }), enumerableKeys);
            symbolKeys = (0, filter_1.default)((0, allKeys_1.default)(data, {
                prototype: false,
                symbol: true,
            }), function (key) {
                return typeof key === 'symbol';
            });
        }
        if ((0, isArr_1.default)(data) && data.length > 100) {
            types.unshift('virtual');
            isBigArr = true;
            var idx_1 = 0;
            var map_1 = {};
            (0, each_1.default)((0, chunk_1.default)(data, 100), function (val) {
                var obj = Object.create(null);
                var startIdx = idx_1;
                var key = '[' + startIdx;
                (0, each_1.default)(val, function (val) {
                    obj[idx_1] = val;
                    map_1[idx_1] = true;
                    idx_1++;
                });
                var endIdx = idx_1 - 1;
                key += (endIdx - startIdx > 0 ? ' … ' + endIdx : '') + ']';
                virtualData[key] = obj;
            });
            virtualKeys = (0, keys_1.default)(virtualData);
            enumerableKeys = (0, filter_1.default)(enumerableKeys, function (val) { return !map_1[val]; });
        }
        (0, each_1.default)(types, function (type) {
            var typeKeys = [];
            if (type === 'symbol') {
                typeKeys = symbolKeys;
            }
            else if (type === 'unenumerable') {
                typeKeys = unenumerableKeys;
            }
            else if (type === 'virtual') {
                typeKeys = virtualKeys;
            }
            else {
                typeKeys = enumerableKeys;
            }
            if (!isBigArr) {
                (0, naturalSort_1.default)(typeKeys);
            }
            for (var i = 0, len = typeKeys.length; i < len; i++) {
                var key = (0, toStr_1.default)(typeKeys[i]);
                var val = '';
                var descriptor = Object.getOwnPropertyDescriptor(data, key);
                var hasGetter = descriptor && descriptor.get;
                var hasSetter = descriptor && descriptor.set;
                if (hasGetter && !_this.options.accessGetter) {
                    val = '(...)';
                }
                else {
                    try {
                        if (type === 'virtual') {
                            val = virtualData[key];
                        }
                        else {
                            val = self[key];
                        }
                        if ((0, isPromise_1.default)(val)) {
                            ;
                            val.catch(noop_1.default);
                        }
                    }
                    catch (e) {
                        if (e instanceof Error) {
                            val = e.message;
                        }
                        else {
                            val = (0, toStr_1.default)(e);
                        }
                    }
                }
                ret += _this.createEl(key, data, val, type, firstLevel);
                if (hasGetter) {
                    ret += _this.createEl("get ".concat(key), data, descriptor.get, type, firstLevel);
                }
                if (hasSetter) {
                    ret += _this.createEl("set ".concat(key), data, descriptor.set, type, firstLevel);
                }
            }
        });
        var proto = (0, getProto_1.default)(data);
        if (!firstLevel && proto) {
            if (ret === '') {
                var id = visitor.set(proto, {
                    self: data,
                });
                this.map[id] = proto;
                ret = this.objToHtml(proto);
            }
            else {
                ret += this.createEl('__proto__', self || data, proto, 'proto');
            }
        }
        return ret;
    };
    ObjectViewer.prototype.createEl = function (key, self, val, keyType, firstLevel) {
        if (firstLevel === void 0) { firstLevel = false; }
        var _a = this, visitor = _a.visitor, c = _a.c;
        var t = typeof val;
        var valType = (0, type_1.default)(val, false);
        if (keyType === 'virtual')
            valType = key;
        if (val === null) {
            return "<li>".concat(wrapKey(key), "<span class=\"").concat(c('null'), "\">null</span></li>");
        }
        else if ((0, isNum_1.default)(val) || (0, isBool_1.default)(val)) {
            return "<li>".concat(wrapKey(key), "<span class=\"").concat(c(t), "\">").concat((0, util_1.encode)(val), "</span></li>");
        }
        if (valType === 'RegExp')
            t = 'regexp';
        if (valType === 'Number')
            t = 'number';
        if (valType === 'Number' || valType === 'RegExp') {
            return "<li>".concat(wrapKey(key), "<span class=\"").concat(c(t), "\">").concat((0, util_1.encode)(val.value), "</span></li>");
        }
        else if (valType === 'Undefined' || valType === 'Symbol') {
            return "<li>".concat(wrapKey(key), "<span class=\"").concat(c('special'), "\">").concat((0, lowerCase_1.default)(valType), "</span></li>");
        }
        else if (val === '(...)') {
            return "<li>".concat(wrapKey(key), "<span class=\"").concat(c('special'), "\">").concat(val, "</span></li>");
        }
        else if ((0, isObj_1.default)(val)) {
            var visitedObj = visitor.get(val);
            var id = void 0;
            if (visitedObj) {
                id = visitedObj.id;
            }
            else {
                var extra = {};
                if (keyType === 'proto') {
                    extra.self = self;
                }
                id = visitor.set(val, extra);
                this.map[id] = val;
            }
            var objAbstract = getObjAbstract(val, valType) || (0, upperFirst_1.default)(t);
            var icon = firstLevel
                ? ''
                : "<span class=\"".concat(c('expanded collapsed'), "\"><span class=\"").concat(c('icon icon-caret-right'), "\"></span><span class=\"").concat(c('icon icon-caret-down'), "\"></span></span>");
            var obj = "<li ".concat(firstLevel ? 'data-first-level="true"' : '', " ").concat('data-object-id="' + id + '"', ">").concat(icon).concat(wrapKey(key), "<span class=\"").concat(c('open'), "\">").concat(firstLevel ? '' : objAbstract, "</span><ul class=\"").concat(c(t), "\" ").concat(firstLevel ? '' : 'style="display:none"', ">");
            if (firstLevel)
                obj += this.objToHtml(val);
            return obj + "</ul><span class=\"".concat(c('close'), "\"></span></li>");
        }
        function wrapKey(key) {
            if (firstLevel)
                return '';
            if ((0, isObj_1.default)(val) && keyType === 'virtual')
                return '';
            var keyClass = c('key');
            if (keyType === 'unenumerable' ||
                keyType === 'proto' ||
                keyType === 'symbol') {
                keyClass = c('key-lighter');
            }
            return "<span class=\"".concat(keyClass, "\">").concat((0, util_1.encode)(key), "</span>: ");
        }
        return "<li>".concat(wrapKey(key), "<span class=\"").concat(c(typeof val), "\">\"").concat((0, util_1.encode)(val), "\"</span></li>");
    };
    ObjectViewer.prototype.render = function () {
        this.$container.html(this.objToHtml(this.data, true));
    };
    ObjectViewer.prototype.bindEvent = function () {
        this.$container.on('click', 'li', this.onItemClick);
    };
    return ObjectViewer;
}(Component_1.default));
exports.default = ObjectViewer;
module.exports = (0, extend_1.default)(ObjectViewer, exports);
module.exports.default = ObjectViewer;
function getObjAbstract(data, type) {
    if (!type)
        return;
    if (type === 'Function') {
        return (0, util_1.getFnAbstract)((0, toSrc_1.default)(data));
    }
    if (type === 'Array') {
        return "Array(".concat(data.length, ")");
    }
    return type;
}
